<template>
  <div>
    <v-dialog v-model="value" persistent max-width="500px" scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">
            {{ $t('configuration.general_settings.institution_qr_code') }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-img :src="this.qr"></v-img>
              </v-flex>
              <v-flex xs12 style="text-align: -webkit-center">
                <v-btn
                  block
                  dark
                  class="gradiente"
                  style="border-radius: 33px; width: 200px"
                  v-show="this.qr"
                  :href="this.qr"
                  target="_blank"
                >
                  {{ $t('generic.download') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="working.wUpdate" flat @click="close">
            {{ $t('generic.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { email, required } from 'vuelidate/lib/validators'
import { funciones } from '../../Mixins/Funciones.js'

export default {
  components: {},
  mixins: [funciones],
  props: ['value', 'qr'],
  validations: {
    userForm: {
      firstName: { required },
      lastName: { required },
      mail: { required, email },
    },
  },
  data: () => ({
    userForm: {
      webRole: {},
    },
    userImg: null,
    working: {
      wUpdate: false,
      wImage: false,
    },
    toast: {
      success: false,
      failed: false,
      eMessage: 'Ups ocurrió un error',
    },
    modals: {
      QRcoll: false,
      cPassword: false,
      image: false,
    },
    flags: {
      updateImage: false,
    },
    url: '',
  }),
  watch: {
    value() {
      if (this.value) {
        this.url = this.qr
      } else {
        this.userform = {}
      }
    },
  },
  methods: {
    close() {
      this.$emit('input', !this.value)
    },
  },
}
</script>
